import { render, staticRenderFns } from "./PrintTagsIndex.vue?vue&type=template&id=24ad451c&scoped=true&"
import script from "./PrintTagsIndex.vue?vue&type=script&lang=js&"
export * from "./PrintTagsIndex.vue?vue&type=script&lang=js&"
import style0 from "./PrintTagsIndex.vue?vue&type=style&index=0&id=24ad451c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ad451c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VCardText,VCol,VRow,VSwitch})
